// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/Users/James/Repositories/gatsby-lego/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-jsx": () => import("/Users/James/Repositories/gatsby-lego/src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-christmas-jsx": () => import("/Users/James/Repositories/gatsby-lego/src/pages/christmas.jsx" /* webpackChunkName: "component---src-pages-christmas-jsx" */),
  "component---src-pages-index-jsx": () => import("/Users/James/Repositories/gatsby-lego/src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

exports.data = () => import("/Users/James/Repositories/gatsby-lego/.cache/data.json")

